import Service from "../../../Service";
import Axios from "../../../Config/API";
import {
    IRelatorioHistorico,
    IRelatorioPesquisa,
    IRelatorioRegua,
    IRelatorioReguaBaseRequest,
    IRelatorioReguaRequest,
} from "../../../../Interfaces/Automacao/Regua/RelatorioDeEnvioRegua/RelatorioDeEnvioReguaInterfaces";

export const ListarRelatorioDeEnvioReguaService = async <
    TResponseType extends IRelatorioRegua | Blob
>(
    req: IRelatorioReguaRequest
) =>
    Service(
        Axios.post<TResponseType>(
            `/automacao/relatoriodeenvio/listarrelatorioacompanhamentoreguacobrancatipoacaoperiodo`,
            { ...req, DT_ENVIO: req.DT_ENVIO, exportExcel: req.exportExcel },
            { responseType: req.exportExcel ? "blob" : "json" }
        )
    );

export const ListarRelatorioDeEnvioPesquisaService = async (
    req: IRelatorioReguaBaseRequest
) =>
    Service(
        Axios.get<Array<IRelatorioPesquisa>>(
            `/automacao/relatoriodeenvio/listarrelatorioacompanhamentoreguapesquisaperiodo?dtInicial=${req.dtInicial}&dtFinal=${req.dtFinal}`
        )
    );

export const ListarRelatorioDeEnvioHistoricoService = async <
    TResponseType extends IRelatorioHistorico | Blob
>(
    req: IRelatorioReguaBaseRequest,
    pagina: number,
    exportExcel?: boolean
) =>
    Service(
        Axios.get<TResponseType>(
            `/automacao/relatoriodeenvio/listacasocobrancafilaatendimentohistorico?DT_INICIAL=${req.dtInicial}&DT_FINAL=${req.dtFinal}&exportExcel=${exportExcel}&Pagina=${pagina}`,
            { responseType: exportExcel ? "blob" : "json" }
        )
    );
